export class ExcluirServicosMassaRequest {
    idsServico: number[] = [];
}
